// import React from "react";
// import "../css/StatCard.css";

// const StatCard = ({ count, label, color, percentage, icon }) => {
//   const strokeDasharray = `${percentage}, 100`;

//   return (
//     <div className="stat-card">
//       <div className="stat-ring">
//         <svg
//           width="60"
//           height="60"
//           viewBox="0 0 36 36"
//           className="circular-chart"
//         >
//           <path
//             className="circle-bg"
//             d="M18 2.0845
//               a 15.9155 15.9155 0 0 1 0 31.831
//               a 15.9155 15.9155 0 0 1 0 -31.831"
//             fill="none"
//             stroke="#eee"
//             strokeWidth="3.8"
//           />
//           <path
//             className="circle"
//             stroke={color}
//             d="M18 2.0845
//               a 15.9155 15.9155 0 0 1 0 31.831
//               a 15.9155 15.9155 0 0 1 0 -31.831"
//             fill="none"
//             strokeDasharray={strokeDasharray}
//             strokeWidth="3.8"
//           />
//         </svg>
//         <div className="stat-icon">{icon}</div>
//         <span className="stat-count">{count}</span>
//       </div>
//       <p className="stat-label">{label}</p>
//     </div>
//   );
// };

// export default StatCard;

// import React, { useEffect, useState } from "react";
// import "../css/StatCard.css";

// const StatCard = ({ count, label, color, percentage, icon }) => {
//   const [progress, setProgress] = useState(0);

//   useEffect(() => {
//     let start = 0;
//     const duration = 1000; // animation duration in ms
//     const frameRate = 10; // update every 10ms
//     const totalFrames = duration / frameRate;
//     const increment = percentage / totalFrames;

//     const interval = setInterval(() => {
//       start += increment;
//       if (start >= percentage) {
//         start = percentage;
//         clearInterval(interval);
//       }
//       setProgress(start.toFixed(2));
//     }, frameRate);

//     return () => clearInterval(interval);
//   }, [percentage]);

//   return (
//     <div className="stat-card">
//       <div className="stat-ring">
//         <svg
//           width="60"
//           height="60"
//           viewBox="0 0 36 36"
//           className="circular-chart"
//         >
//           <path
//             className="circle-bg"
//             d="M18 2.0845
//               a 15.9155 15.9155 0 0 1 0 31.831
//               a 15.9155 15.9155 0 0 1 0 -31.831"
//             fill="none"
//             stroke="#eee"
//             strokeWidth="3.8"
//           />
//           <path
//             className="circle"
//             stroke={color}
//             d="M18 2.0845
//               a 15.9155 15.9155 0 0 1 0 31.831
//               a 15.9155 15.9155 0 0 1 0 -31.831"
//             fill="none"
//             strokeDasharray={`${progress}, 100`}
//             strokeWidth="3.8"
//           />
//         </svg>
//         <div className="stat-icon">{icon}</div>
//         <span className="stat-count">{count}</span>
//       </div>
//       <p className="stat-label">{label}</p>
//     </div>
//   );
// };

// export default StatCard;


import React, { useEffect, useState } from "react";
import "../css/StatCard.css";

const StatCard = ({ count, label, color, percentage, icon }) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    let start = 0;
    const duration = 1000;
    const frameRate = 10;
    const totalFrames = duration / frameRate;
    const increment = percentage / totalFrames;

    const interval = setInterval(() => {
      start += increment;
      if (start >= percentage) {
        start = percentage;
        clearInterval(interval);
      }
      setProgress(start.toFixed(2));
    }, frameRate);

    return () => clearInterval(interval);
  }, [percentage]);

  return (
    <div className="stat-card">
      <div className="stat-ring">
        <svg className="circular-chart" viewBox="0 0 36 36">
          <path
            className="circle-bg"
            d="M18 2.0845
              a 15.9155 15.9155 0 0 1 0 31.831
              a 15.9155 15.9155 0 0 1 0 -31.831"
            fill="none"
            stroke="#eee"
            strokeWidth="2"
             transform="rotate(215 18 18)"
          />
          <path
            className="circle"
            stroke={color}
            d="M18 2.0845
              a 15.9155 15.9155 0 0 1 0 31.831
              a 15.9155 15.9155 0 0 1 0 -31.831"
            fill="none"
            strokeLinecap="round"
            strokeDasharray={`${progress}, 100`}
            strokeWidth="4.5"
             transform="rotate(215 18 18)"
          />
        </svg>
        <div className="stat-center">
          <div className="stat-icon">{icon}</div>
          <div className="stat-count">{count}</div>
        </div>
      </div>
      <p className="stat-label">{label}</p>
    </div>
  );
};

export default StatCard;
